import { AssetProcessingStates } from '@cube3/common/model/types';

/** The states translated in user understandable language. */
export const uploadStateMessages: { [key in AssetProcessingStates]: string } = {
  AssetProcessingStatusUploading: 'Uploading file',
  AssetUploadStatusPending: 'Waiting to upload file',
  AssetProcessingStatusProcessing: 'Generating previews',
  AssetProcessingStatusComposing: 'Rendering asset',
  AssetProcessingStatusPending: 'Waiting to generate previews',
  AssetUploadStatusFailed: 'Failed to upload file',
  AssetUploadStatusUplodadInitFailed: 'Failed to create upload',
  AssetUploadStatusUplodadMissing: `Upload hasn't finished`,
  AssetProcessingStatusFailed: 'Processing failed',
  AssetUploadStatusPaused: 'Upload paused',
  AssetProcessingStatusComplete: undefined,
  //
  AssetProcessingStatusUnknown: 'Processing status unknown',
  AssetProcessingStatusScanning: 'Processing status scanning'
};

type RequiredClasses = {
  uploadText: string;
  defaultText: string;
  uploadTextError: string;
};
export function getTextClass<C extends RequiredClasses>(
  isHovered,
  uploadState,
  classes: C
): string {
  let textClass = classes.uploadText;

  if (
    uploadState === 'AssetUploadStatusFailed' ||
    uploadState === 'AssetUploadStatusUplodadInitFailed' ||
    uploadState === 'AssetUploadStatusUplodadMissing' ||
    uploadState === 'AssetUploadStatusPaused'
  ) {
    textClass = classes.uploadTextError;
  }

  if (isHovered && uploadState === 'AssetProcessingStatusUploading') {
    textClass = classes.defaultText;
  }

  if (isHovered && uploadState === 'AssetUploadStatusPaused') {
    textClass = classes.defaultText;
  }

  if (isHovered && uploadState === 'AssetUploadStatusPending') {
    textClass = classes.defaultText;
  }

  return textClass;
}

/** Returns additional information underlaying the title of the popup   */
export function getPopupSubText(
  isHovered,
  uploadState,
  canResume = false
): string {
  let text = uploadStateMessages[uploadState];

  if (isHovered && uploadState === 'AssetProcessingStatusUploading') {
    text = 'Click to pause upload';
  }

  if (isHovered && uploadState === 'AssetUploadStatusPaused') {
    text = 'Click to resume upload';
  }

  if (isHovered && uploadState === 'AssetUploadStatusPending') {
    text = 'Click to start upload';
  }

  if (isHovered && uploadState === 'AssetUploadStatusFailed' && canResume) {
    text = 'Click to retry upload';
  }

  return text;
}

/* 
    function to return a boolean based on upload state
    */

export function getDisabledBoolean(uploadState: AssetProcessingStates) {
  return uploadState === 'AssetProcessingStatusUploading' ||
    uploadState === 'AssetUploadStatusPending' ||
    uploadState === 'AssetUploadStatusFailed' ||
    uploadState === 'AssetUploadStatusUplodadInitFailed' ||
    uploadState === 'AssetUploadStatusUplodadMissing'
    ? true
    : false;
}

/* 
    function to return a boolean based on upload state
    */

export function isUploadProcessingOrPending(
  uploadState: AssetProcessingStates
) {
  return uploadState === 'AssetProcessingStatusProcessing' ||
    uploadState === 'AssetProcessingStatusPending' ||
    uploadState === 'AssetProcessingStatusComposing'
    ? true
    : false;
}
